<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import 'swiper/dist/css/swiper.css'
import { isObjectLike } from 'lodash'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import LumaCalculator from '@/components/helper/LumaCalculator'

export default {
  name: 'OverlayGallery',
  components: {
    swiper,
    swiperSlide,
    LumaCalculator,
  },
  props: {
    isOpen: Boolean,
    swiperSlides: Array,
    overlayIndex: Number,
  },
  data() {
    return {
      activeIndex: 0,
      swiperOption: {
        loop: true,
        init: false,
        slidesPerView: 1,
        observer: true,
        observeParent: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        initialSlide: this.overlayIndex,
      },
      luma: null,
      imageSource: null,
      indicators: 'bright',
    }
  },
  computed: {
    opened: {
      set() {
        this.$emit('onCloseOverlay')
      },
      get() {
        return this.isOpen
      },
    },
  },
  watch: {
    luma: {
      immediate: true,
      handler(val) {
        this.indicators = val !== null && val > 155 ? 'dark' : 'bright'
      },
    },
  },
  mounted() {
    this.$refs.swiper.swiper.init()
    this.onSlideChange()
  },
  methods: {
    isImage(attachment) {
      return (
        (
          isObjectLike(attachment) && attachment.type.indexOf('image') > -1
        ) ||
        (
          !isObjectLike(attachment) &&
          attachment.match(/\.(jpeg|jpg|gif|png)$/) != null
        )
      )
    },
    getLink(attachment) {
      return isObjectLike(attachment) && attachment.link
        ? attachment.link
        : attachment
    },
    onLumaCalculated(value) {
      this.luma = value
    },
    onSlideChange() {
      const swiper = this.$refs.swiper.swiper
      const isInitialized = swiper.initialized
      const index = isInitialized ? swiper.activeIndex || 0 : 0
      const slides =
        document.querySelectorAll('.v-dialog--active .swiper-wrapper .swiper-slide')
      const slide = slides.item(index)
      const link = slide.getAttribute('data-link')
      const isImage = slide.getAttribute('data-is-image')
      if (isImage) {
        this.imageSource = new URL(link, document.baseURI).href
      } else {
        this.imageSource = null
        this.luma = slide.offsetHeight < swiper.height - 72 ? 256 : 1
      }
    },
  },
}
</script>
